import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BehaviorSubjectService{
    isUserLogin: boolean = false;
    public _isUserLoginBS = new BehaviorSubject<boolean>(this.isUserLogin);
    isUserLoginBS = this._isUserLoginBS.asObservable().pipe(
        distinctUntilChanged(),
    );

    constructor(){}

    changeUserLoginStatus(status: boolean){
        this._isUserLoginBS.next(status);
    }

}